import { ForeignOutflowMetric } from './../foreign-outflow-metric';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-foreign-outflow-details',
    templateUrl: './foreign-outflow-details.component.html',
    styleUrls: ['./foreign-outflow-details.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ForeignOutflowDetailsComponent implements OnInit {

    tableData: any[] = [];
    currency: string;
    totalOutAmount = null;
    totalInAmount = null;
    totalBaseOutAmount = 0;
    totalBaseInAmount = 0;
    showTable = false;
    constructor() { }

    ngOnInit() {
    }

    showMetric(metric: ForeignOutflowMetric) {
        this.tableData = metric.breakDown;
        this.currency = metric.currency;
        metric.breakDown.forEach((bd) => {
            this.totalBaseOutAmount += bd.baseOutAmount;
            this.totalBaseInAmount += bd.baseInAmount;
        });
        this.showTable = true;
    }
}
